import { gql } from '@apollo/client';

export const GET_MATERIALITY_ASSESSMENT = gql`
  query GetMaterialityAssessment($year: Int!) {
    materialityAssessment(year: $year) {
      id
      companyId
      year
      financialThreshold
      impactThreshold
      topics {
        id
        materialityAssessment {
          id
        }
        isActive
        against {
          id
        }
        favor {
          id
        }
        comments {
          id
          userId
          materialityAssessmentTopicId
          comment
        }
        materialTopic {
          area
          id
          title
          type
          reportChapter {
            id
          }
        }
        materiality {
          overallMateriality
          financialMateriality
          impactMateriality
        }
        materialityLegacy {
          overallMateriality
          financialMateriality
          impactMateriality
        }
        evaluation {
          impactDescription
          financialDescription
          impactScale
          impactScope
          impactIrreversibility
          financialSignificance
          financialProbability
        }
      }
      identificationRequests {
        id
        materialityAssessment {
          id
        }
        dueDate
        status
        stakeholder {
          id
          email
          firstName
          lastName
          userGroupId
        }
      }
      evaluationRequests {
        id
        materialityAssessment {
          id
        }
        dueDate
        status
        statusLegacy
        userGroupIds
        stakeholder {
          id
          email
          firstName
          lastName
          userGroupId
        }
        topicEvaluations {
          materialityAssessmentTopicId
          evaluationRequestId
          impacts {
            id
            materialityAssessmentTopic {
              id
              materialTopic {
                title
              }
            }
            evaluationRequest {
              id
            }
            userGroupId
            parent {
              id
            }
            createdDate
            title
            description
            type
            occurenceType
            uncontrolledDuration
            extentOfImpact
            degreeOfCoverage
            irreversibility
            occurenceProbability
            isMaterial
            isPreDefined
            preDefinedStatus
          }
          riskOpportunities {
            id
            materialityAssessmentTopic {
              id
              materialTopic {
                title
              }
            }
            evaluationRequest {
              id
            }
            userGroupId
            parent {
              id
            }
            createdDate
            title
            description
            type
            uncontrolledDuration
            significance
            probability
            isMaterial
            isPreDefined
            preDefinedStatus
          }
          isRequestedTopic
        }
        topicEvaluationsLegacy {
          topicId
          result {
            impactDescription
            financialDescription
            impactScale
            impactScope
            impactIrreversibility
            financialSignificance
            financialProbability
          }
        }
      }
    }
  }
`;

export const GET_STAKEHOLDER_GROUPS = gql`
  query StakeholderGroups($year: Int!) {
    stakeholderGroups(year: $year) {
      id
      userGroupId
      materialityAssessmentId
      power
      powerDescription
      interest
      interestDescription
      isActivated
    }
    userGroups {
      id
      name
      category
    }
  }
`;

export const GET_SELECT_DATA_OVERVIEW = gql`
  query DataSelectionOverview($year: Int!) {
    dataSelectionOverview(year: $year) {
      title
      status
      availableDataPoints
      impacts {
        id
        title
        materialityAssessmentTopic {
          id
        }
      }
      riskOpportunities {
        id
        title
        materialityAssessmentTopic {
          id
        }
        type
      }
      reportChapterId
    }
  }
`;

export const GET_MATERIALITY_REMINDERS = gql`
  query MaterialityReminders($assessmentId: ID!, $type: MaterialityRequestType!) {
    materialityReminders(assessmentId: $assessmentId, type: $type) {
      createDate
      evaluationRequestId
      executionDate
      id
      identificationRequestId
      recipientId
      status
    }
  }
`;

export const GET_PUBLIC_PRE_SELECTION_REQUEST = gql`
  query PublicPreSelectionRequest($preSelectionRequestId: ID!) {
    publicPreSelectionRequest(preSelectionRequestId: $preSelectionRequestId) {
      id
      status
      year
      materialityAssessmentTopics {
        id
        title
        materialityVoteOption
      }
      additionalTopicsFeedback
    }
  }
`;
